import { FetchedLocale, FormattedLocales } from "../types/locales";

const localesMapper = (locales: FetchedLocale[]): FormattedLocales => {
  if (!locales) return {};
  const formattedLocales: FormattedLocales = {};
  locales.map(locale => {
    formattedLocales[locale.key] = locale.translation;
  });
  return formattedLocales;
};

export default localesMapper;
